"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IconRooms = function IconRooms(_ref) {
  var className = _ref.className,
      color = _ref.color;
  return /*#__PURE__*/_react.default.createElement("svg", {
    className: className,
    width: "30",
    height: "30",
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.482 10.4173L23.082 8.83332V4.94532C23.082 4.7671 23.0112 4.59617 22.8852 4.47015C22.7592 4.34412 22.5883 4.27332 22.41 4.27332H19.05C18.8718 4.27332 18.7009 4.34412 18.5749 4.47015C18.4488 4.59617 18.378 4.7671 18.378 4.94532V5.69532L15.378 3.72132C15.2611 3.64239 15.1232 3.60022 14.982 3.60022C14.8409 3.60022 14.703 3.64239 14.586 3.72132L4.51804 10.4173C4.41939 10.4831 4.33866 10.5723 4.28314 10.6771C4.22762 10.7818 4.19906 10.8988 4.20004 11.0173V25.6813C4.20004 25.7759 4.21866 25.8695 4.25484 25.9569C4.29103 26.0442 4.34406 26.1236 4.41092 26.1904C4.47778 26.2573 4.55715 26.3103 4.6445 26.3465C4.73186 26.3827 4.82548 26.4013 4.92004 26.4013H25.08C25.1746 26.4013 25.2682 26.3827 25.3556 26.3465C25.4429 26.3103 25.5223 26.2573 25.5892 26.1904C25.656 26.1236 25.709 26.0442 25.7452 25.9569C25.7814 25.8695 25.8 25.7759 25.8 25.6813V11.0113C25.8 10.8938 25.771 10.7781 25.7155 10.6745C25.66 10.5708 25.5798 10.4825 25.482 10.4173ZM19.536 7.96932C19.4901 7.99509 19.4387 8.00949 19.386 8.01132C19.4385 8.00863 19.4898 7.99429 19.536 7.96932ZM23.85 24.4573H13.2V19.8013H23.8588L23.85 24.4573ZM11.4 19.8013V24.4573H6.15004V19.8013H11.4ZM16.8 18.0013H6.15004V13.2013H16.8V18.0013ZM23.8622 18.0013H18.6V13.2013H23.8712L23.8622 18.0013ZM15 5.89932L6.62497 11.4013H23.3781L21.6 10.2613C21.4631 10.1808 21.3495 10.066 21.2706 9.92813C21.1916 9.79027 21.1501 9.63418 21.15 9.47532V6.21132H20.328V7.66932C20.3277 7.83898 20.2815 8.00539 20.1943 8.15097C20.1072 8.29655 19.9824 8.4159 19.833 8.49641C19.6837 8.57691 19.5154 8.6156 19.3459 8.60836C19.1764 8.60113 19.012 8.54826 18.87 8.45532L17.472 7.53732L15 5.89932Z",
    fill: color
  }));
};

IconRooms.defaultProps = {
  color: 'black'
};
IconRooms.propTypes = {
  color: _propTypes.string,
  className: _propTypes.string
};
var _default = IconRooms;
exports.default = _default;